<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div style="position:relative;">
          <h2><a href="/roll_outs"><i class="fa fa-angle-double-left"></i></a>Roll Out Details</h2>
          <template v-if="isAdmin">
            <button type="button" class="btn btn-sm btn-warning"
              @click="archiveRollOut(rollOut)"
              v-if="! rollOut.archived_at"
              style="position: absolute;right: 0;top: 0;"
            >
              Archive <i class="fa fa-archive"></i>
            </button>
            <button type="button" class="btn btn-sm btn-warning"
              @click="unArchiveRollOut(rollOut)"
              v-if="rollOut.archived_at"
              style="position: absolute;right: 0;top: 0;"
            >
              Unarchive <i class="fa fa-undo-alt"></i>
            </button>
          </template>
        </div>
        <p class="text-muted" v-if="rollOut.trial">Rolled Out from Test <a :href="`/trials/${rollOut.trial.id}`">{{`${rollOut.trial.key_account.name} ${rollOut.trial.distributor} ${rollOut.trial.country.name}`}}</a> at {{rollOut.created_at}}</p>
        <a :href="`/storage/${logoPath}`" v-if="logoPath" data-lity>
          <img :src="`/storage/${logoPath}`" style="max-height:250px;">
        </a>
        <div class="accordion" id="accordionShow">
          <step-part header="General">
            <create-step-1 :nav="false" stepType="rollOut"
              @update="update" :uploadUrl="`/roll_outs/${this.rollOut.id}/logo`"
              @addChange="openAddChangeModal"
              @openEditChangeModal="openEditChangeModal"
              @deleteChange="deleteChange"
            />
          </step-part>
          <step-part header="Agreements">
            <agreement-files-rows
              :rollOut="rollOut"
            />
          </step-part>
          <step-part header="Key Account">
            <create-step-2 :nav="false" stepType="rollOut"
              @update="update"
              :rollOut="rollOut"
            />
          </step-part>
          <step-part header="Equipment and Printers">
            <create-step-3 :nav="false" stepType="rollOut"
              @update="update"
            />
          </step-part>
          <step-part header="Products">
            <create-step-4 :nav="false" stepType="rollOut"
              @update="update"
              :trialId="rollOut.id"
            />
          </step-part>
          <step-part header="Communication">
            <create-step-5 :nav="false" stepType="rollOut" :canUploadImages="true"
              @update="update"
              @openDocumentUploadModal="openDocumentUploadModal"
            />
          </step-part>
          <step-part header="General Store Pictures">
            <general-store-pictures
              @openGeneralUploadModal="openGeneralUploadModal"
              @openGeneralFolderModal="openGeneralFolderModal"
            />
          </step-part>
          <step-part header="Promotion">
            <create-step-6 :nav="false" stepType="rollOut" :canUploadImages="true"
              @update="update"
              :rollOutId="rollOut.id"
            />
          </step-part>
        </div>
      </div>
    </div>
    <document-upload-modal :url="documentUploadUrl" :documents="documents"
      @fileUploaded="addDocumentToCommunication"
    />
    <general-documents-upload-modal
      :url="generalDocumentsUploadUrl"
      @fileUploaded="addDocumentToRollOut"
      :documents="documentsFolder ? documentsFolder.documents : []"
      :isForFolder="documentsFolder"
    />
    <general-documents-folder-modal
      :url="`/roll_outs/${rollOut.id}/document_folders`"
    />
    <add-change-modal :rollOutId="rollOut.id"
      @changeAdded="addChangeToRollOut"
    />
    <edit-change-modal v-if="change"
      :rollOutId="rollOut.id"
      :initChange="change"
      @changeUpdated="updateChange"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: ['rollOut'],
    data() {
      return {
        isAdmin: window.isAdmin,
        documentUploadUrl: '/',
        documents: [],
        documentsFolder: null,
        printerMap: {
          kiosk: {
            new: {
              'p_4_n_305_6r': '305 Printer 6R',
              'p_4_n_305_5r': '305 Printer 5R',
              'p_4_n_6900_6r': '6900 new 6R',
              'p_4_n_6900_5r': '6900 new 5R',
            },
            ref: {
              'p_4_r_6800_6r': '6800 ref 6R',
              'p_4_r_6850_6r': '6850 ref 6R',
            },
          },
          apex: {
            new: {
              'p_4_n_7000_new_6r': '7000 NEW 6R',
              'p_4_n_7000_new_5r': '7000 NEW 5R',
            },
            ref: {
              'p_4_r_7000_ref': '7000 ref',
              'p_4_r_7015_ref': '7015 ref',
            },
          },
          standalone: {
            new: {
              'p_4_n_305_6r': '305 Printer 6R',
              'p_4_n_305_5r': '305 Printer 5R',
              'p_4_n_6900_new_6r': '6900 new 6R',
              'p_4_n_6900_new_5r': '6900 new 5R',
              'p_4_n_7000_new_6r': '7000 NEW 6R',
              'p_4_n_7000_new_5r': '7000 NEW 5R',
            },
            ref: {
              'p_4_r_7000_ref': '7000 ref',
              'p_4_r_7015_ref': '7015 ref',
              'p_4_r_6800_ref': '6800 ref',
              'p_4_r_6850_ref': '6850 ref',
            },
          },
          large: {
            new: {
              'p_8_n_88xx': '88xx NEW',
              'p_8_n_d4600': 'D4600 NEW',
            },
            ref: {
              'p_8_r_8800': '8800 ref',
              'p_8_r_8810': '8810 ref',
              'p_8_r_d4000': 'D4000 ref',
            },
          },
        },
        change: null,
      }
    },
    computed: {
      ...mapState(['logoPath']),
      generalDocumentsUploadUrl() {
        return this.documentsFolder ?
          `/roll_outs/${this.rollOut.id}/general_documents?folder=${this.documentsFolder.id}` :
          `/roll_outs/${this.rollOut.id}/general_documents`
      }
    },
    methods: {
      addDocumentToCommunication(document) {
        this.documents.push(document)
      },
      update() {
        axios.put(`/roll_outs/${this.rollOut.id}`, this.$store.getters.postData).then(({data}) => {
          window.notification.success(`Roll Out has been updated`, 'Success!')
          window.removeEventListener('beforeunload', this.preventClose)
        })
      },
      openDocumentUploadModal(payload) {
        this.documentUploadUrl = `/roll_outs/${this.rollOut.id}/${payload.type}/${payload.communication.id}/documents`
        let existingCom = null;
        if (payload.type === 'pos_communications') {
          existingCom = this.$store.getters.existingPosCommunication(payload.communication)
        } else if (payload.type === 'social_media_communications') {
          existingCom = this.$store.getters.existingSmCommunication(payload.communication)
        } else {
          existingCom = this.$store.getters.existingKaCommunication(payload.communication)
        }
        if (! existingCom) {
          existingCom = {
            id: payload.communication.id,
            documents: []
          }
          if (payload.type === 'pos_communications') {
            this.$store.commit('addTrialPosCommunications', existingCom)
          } else if (payload.type === 'social_media_communications') {
            this.$store.commit('addTrialSmCommunications', existingCom)
          } else {
            this.$store.commit('addTrialKaCommunications', existingCom)
          }
        }
        this.documents = existingCom.documents
        $('#documentsUploadModal').modal('show')
      },
      preventClose(e) {
        e.preventDefault()
        e.returnValue = ''
      },
      archiveRollOut(rollOut) {
        if (window.confirm(`Do you really want to archive this test?`)) {
          window.axios.put(`/roll_outs/${rollOut.id}/archive`).then(({data}) => {
            window.location.reload()
          })
        }
      },
      unArchiveRollOut(rollOut) {
        if (window.confirm(`Do you really want to unarchive this test?`)) {
          window.axios.put(`/roll_outs/${rollOut.id}/unarchive`).then(({data}) => {
            window.location.reload()
          })
        }
      },
      openGeneralUploadModal(folder = null) {
        this.documentsFolder = folder
        this.$nextTick(() => $('#generalDocumentsUploadModal').modal('show'))
      },
      openGeneralFolderModal() {
        $('#generalDocumentsFolderModal').modal('show')
      },
      addDocumentToRollOut(doc) {
        if (this.documentsFolder) {
          this.documentsFolder.documents.push(doc)
        } else {
          this.$store.commit('addGeneralDocument', doc)
        }
      },
      openAddChangeModal() {
        $('#addChangeModal').modal('show')
      },
      addChangeToRollOut(change) {
        // window.notification.success(`Lorem Ipsum has been added`, 'Success!')
        $('#addChangeModal').modal('hide')
        this.$store.commit('addChange', change)
      },
      openEditChangeModal(change) {
        this.change = change
        this.$nextTick(() => $('#updateChangeModal').modal('show'))
      },
      deleteChange(change) {
        if (window.confirm(`Do you really want to delete this Lorem Ipsum?`)) {
          window.axios.delete(`/roll_outs/${this.rollOut.id}/changes/${change.id}`).then(({data}) => {
            this.$store.commit('removeChange', data)
            window.notification.success(`Lorem Ipsum has been deleted`, 'Success!')
          })
        }
      },
      updateChange(change) {
        window.notification.success(`Lorem Ipsum has been saved`, 'Success!')
        $('#updateChangeModal').modal('hide')
        this.$store.commit('updateChange', change)
      },
    },
    created() {
      this.$store.commit('changeSelectedUser', this.rollOut.user)
      this.$store.commit('changeSelectedCountry', this.rollOut.country)
      this.$store.commit('changeSelectedDistributor', this.rollOut.distributor)
      this.$store.commit('changeStartDate', this.rollOut.start_date)
      this.$store.commit('changeTestPeriod', this.rollOut.test_period)
      this.$store.commit('changeLogoPath', this.rollOut.logo_path)
      this.rollOut.changes.forEach(change => this.$store.commit('addChange', change))

      this.$store.commit('changeName', this.rollOut.key_account.name)
      this.$store.commit('changeType', this.rollOut.key_account.type)
      this.$store.commit('changeSalesName', this.rollOut.key_account.sales_name)
      this.$store.commit('changeSalesPhone', this.rollOut.key_account.sales_phone_number)
      this.$store.commit('changeSalesEmail', this.rollOut.key_account.sales_email)
      this.$store.commit('changeMarketingName', this.rollOut.key_account.marketing_name)
      this.$store.commit('changeMarketingPhone', this.rollOut.key_account.marketing_phone_number)
      this.$store.commit('changeMarketingEmail', this.rollOut.key_account.marketing_email)
      this.$store.commit('changeStoresNumber', this.rollOut.key_account.stores)
      this.$store.commit('changeStoresPotentialRollouts', this.rollOut.key_account.potential_rollouts)
      this.$store.commit('changeStoresDescription', this.rollOut.key_account.stores_description)
      this.rollOut.key_account.distributer_files.forEach(doc => this.$store.commit('addDistributerFile', doc))
      this.rollOut.key_account.key_account_files.forEach(doc => this.$store.commit('addKeyAccountFile', doc))

      this.$store.commit('changePrintingDevices', this.rollOut.printing_devices)

      const equipments = []

      if (this.rollOut.kiosk_equipment) {
        this.$store.commit('changeEquipment', 'kiosk')
        equipments.push({
          type: 'kiosk',
          equipment: this.rollOut.kiosk_equipment,
        })
      }

      if (this.rollOut.apex_equipment) {
        this.$store.commit('changeEquipment', 'apex')
        equipments.push({
          type: 'apex',
          equipment: this.rollOut.apex_equipment,
        })
      }

      if (this.rollOut.standalone_equipment) {
        this.$store.commit('changeEquipment', 'standalone')
        equipments.push({
          type: 'standalone',
          equipment: this.rollOut.standalone_equipment,
        })
      }

      equipments.forEach(equipmentUnit => {
        const equipment = equipmentUnit.equipment
        const equipmentType = equipmentUnit.type

        if (equipment.printers_4_new) {
          this.$store.commit('changeSmallPrinters', { key: equipmentType, value:'new' })
          Object.keys(this.printerMap[equipmentType].new).forEach(printerKey => {
            const printer = this.printerMap[equipmentType].new[printerKey]
            const value = equipment[printerKey]
            this.$store.commit('changeSmallPrintersNew', { key: equipmentType, printer, value })
          })
        }
        if (equipment.printers_4_refurbished) {
          this.$store.commit('changeSmallPrinters', { key: equipmentType, value:'refurbished' })
          Object.keys(this.printerMap[equipmentType].ref).forEach(printerKey => {
            const printer = this.printerMap[equipmentType].ref[printerKey]
            const value = equipment[printerKey]
            this.$store.commit('changeSmallPrintersRefurbished', { key: equipmentType, printer, value })
          })
        }
        if (equipment.printers_8_new) {
          this.$store.commit('changeLargePrinters', { key: equipmentType, value:'new' })
          Object.keys(this.printerMap.large.new).forEach(printerKey => {
            const printer = this.printerMap.large.new[printerKey]
            const value = equipment[printerKey]
            this.$store.commit('changeLargePrintersNew', { key: equipmentType, printer, value })
          })
        }
        if (equipment.printers_8_refurbished) {
          this.$store.commit('changeLargePrinters', { key: equipmentType, value:'refurbished' })
          Object.keys(this.printerMap.large.ref).forEach(printerKey => {
            const printer = this.printerMap.large.ref[printerKey]
            const value = equipment[printerKey]
            this.$store.commit('changeLargePrintersRefurbished', { key: equipmentType, printer, value })
          })
        }
        if (equipmentType === 'apex') {
          this.$store.commit('changeApexHeadunitsNew', equipment.headunits_new)
          this.$store.commit('changeApexHeadunitsRefurbished', equipment.headunits_refurbished)
          this.$store.commit('changeApexCabinets', { cabinet: 'APEX 30', value: equipment.cabinet_apex_30 })
          this.$store.commit('changeApexCabinets', { cabinet: 'APEX 40', value: equipment.cabinet_apex_40 })
          this.$store.commit('changeApexCabinets', { cabinet: 'APEX 70', value: equipment.cabinet_apex_70 })
        } else if (equipmentType === 'kiosk') {
          if (equipment.headunits_new) {
            this.$store.commit('changeKioskHeadunits', 'new')
            this.$store.commit('changeKioskHeadunitsNew', { headunit: 'G20', value: equipment.h_n_g20 })
            this.$store.commit('changeKioskHeadunitsNew', { headunit: 'Janus', value: equipment.h_n_janus })
          }
          if (equipment.headunits_refurbished) {
            this.$store.commit('changeKioskHeadunits', 'refurbished')
            this.$store.commit('changeKioskHeadunitsRefurbished', { headunit: 'G4XL 1 ref', value: equipment.h_r_g4xl_1_ref })
            this.$store.commit('changeKioskHeadunitsRefurbished', { headunit: 'G4XL 2 ref', value: equipment.h_r_g4xl_2_ref })
          }
          if (equipment.cabinets_new) {
            this.$store.commit('changeKioskCabinets', 'new')
            this.$store.commit('changeKioskCabinetsNew', { cabinet: 'Skipper 17', value: equipment.cabinet_skipper_17 })
            this.$store.commit('changeKioskCabinetsNew', { cabinet: 'Skipper 24', value: equipment.cabinet_skipper_24 })
            this.$store.commit('changeKioskCabinetsNew', { cabinet: 'Transformer 24', value: equipment.cabinet_tranformer_24 })
            this.$store.commit('changeKioskCabinetsNew', { cabinet: '6900 Cabinet 17', value: equipment.cabinet_6900_cabinet_17 })
          }
          if (equipment.cabinets_refurbished) {
            this.$store.commit('changeKioskCabinets', 'refurbished')
            this.$store.commit('changeKioskCabinetsRefurbished', { cabinet: 'Transformer ref 17', value: equipment.cabinet_transformer_ref_17 })
            this.$store.commit('changeKioskCabinetsRefurbished', { cabinet: 'Transformer ref 24', value: equipment.cabinet_transformer_ref_24 })
          }
        } else {
          if (equipment.connection_pc) this.$store.commit('changeConnection', 'pc')
          if (equipment.connection_mac) this.$store.commit('changeConnection', 'mac')
        }
      })

      this.$store.commit('changeStoresNumber2', this.rollOut.stores)
      this.$store.commit('changeSoftware', this.rollOut.software_version)
      this.$store.commit('changeRbm', this.rollOut.rbm_units)

      this.$store.commit('changeCurrency', this.rollOut.currency)
      this.$store.commit('changeOriginalCurrency', this.rollOut.original_currency)
      this.$store.commit('changeExchangesTo', this.rollOut.exchanges_to)

      this.$store.dispatch('fetchSmallProductsRollOut', this.rollOut.id).then(res => {
        this.rollOut.small_products.forEach(({pivot}) => this.$store.commit('change5RProducts', { product: pivot.small_product_id, value: pivot.price}))
      })
      this.$store.dispatch('fetchMiddleProductsRollOut', this.rollOut.id).then(res => {
        this.rollOut.middle_products.forEach(({pivot}) => this.$store.commit('change6RProducts', { product: pivot.middle_product_id, value: pivot.price}))
      })
      this.$store.dispatch('fetchLargeProductsRollOut', this.rollOut.id).then(res => {
        this.rollOut.large_products.forEach(({pivot}) => this.$store.commit('change8RProducts', { product: pivot.large_product_id, value: pivot.price}))
      })
      this.rollOut.creative_products.forEach(product => this.$store.commit('changeCreativeProducts', product.id))

      this.rollOut.pos_communications.forEach(communication => {
        this.$store.commit('changeCommunicationPOS', communication.id)
        this.$store.commit('addTrialPosCommunications', communication)
      })
      this.rollOut.social_media_communications.forEach(communication => {
        this.$store.commit('changeCommunicationSM', communication.id)
        this.$store.commit('addTrialSmCommunications', communication)
      })
      this.rollOut.key_account_communications.forEach(communication => {
        this.$store.commit('changeCommunicationKA', communication.id)
        this.$store.commit('addTrialKaCommunications', communication)
      })
      this.$store.commit('changeTargetgroup', this.rollOut.targetgroup)

      this.$store.commit('changeCompanyWebsite', this.rollOut.website)

      if (this.rollOut.promo_general_moments) {
        this.$store.commit('changeBrandingGeneral', 'kodakmoments')
      }
      if (this.rollOut.promo_general_branding_co) {
        this.$store.commit('changeBrandingGeneral', 'co')
      }
      if (this.rollOut.promo_general_branding_company) {
        this.$store.commit('changeBrandingGeneral', 'company')
      }

      this.rollOut.roll_out_promotions.forEach(promo => this.$store.commit('addRollOutPromotion', promo))
      this.rollOut.general_documents.forEach(doc => this.$store.commit('addGeneralDocument', doc))

      this.rollOut.general_documents_folders.forEach(folder => this.$store.commit('addGeneralDocumentsFolder', folder))

      $(document).ready(() => {
        $(':input').on('change', () => {
          window.addEventListener('beforeunload', this.preventClose)
        })
      })
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/roll_outs/RollOutShow.vue